import { TractBase } from './base/tract-base';

export class Tract extends TractBase { }